import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import Rollbar from 'rollbar'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './locale'
import Icon from '@/components/Icon'

Vue.config.productionTip = false
Vue.component('multiselect', Multiselect)
Vue.component('datepicker', Datepicker)
Vue.component('icon', Icon)
Vue.use(Toast)

Vue.filter('formatDateWithSeparators', function (value) {
  const date = new Date(value)
  const dateYear = date.getFullYear()
  const dateMonth = date.getMonth() + 1
  const parsedDateMonth = dateMonth < 10 ? '0' + dateMonth : dateMonth
  const dateDay = date.getDate()
  const parsedDay = dateDay < 10 ? '0' + dateDay : dateDay

  return parsedDay + '-' + parsedDateMonth + '-' + dateYear
})

if (process.env.VUE_APP_ENABLE_ROLLBAR) {
  Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err)
    throw err // rethrow
  }

  Vue.prototype.$rollbar = new Rollbar({
    accessToken: process.env.VUE_APP_ENABLE_ROLLBAR,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.NODE_ENV
  })
}

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
